import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, UrlTree } from '@angular/router';

import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { ViMonitorService } from '../services/vi-monitor.service';
import { ViRoutingService } from '../services/vi-routing.service';

@Injectable()
export class ViMonitorHasResultsGuard implements CanActivate {
    constructor(
        private viMonitorService: ViMonitorService,
        private viRoutingService: ViRoutingService
    ) {}

    /**
     * A draft has never run, so it has no results to show.
     * Send the user back to its setup form instead.
     */
    canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        const id: number = +route.paramMap.get('id');

        if (!id || isNaN(id)) {
            return of(this.viRoutingService.hypeUrl());
        }

        return this.viMonitorService.getById(id).pipe(
            map(monitor => {
                if (!monitor) {
                    return this.viRoutingService.hypeUrl();
                }

                return monitor.hasNoResults
                    ? this.viRoutingService.setupUrl(id)
                    : true;
            }),
            catchError(() => of(this.viRoutingService.hypeUrl()))
        );
    }
}
